// extracted by mini-css-extract-plugin
module.exports = {"listItemOl":"NumberListItem_listItemOl__5J6o1 typography_body__vVxn5"};